﻿import config from "../config"
const baseUrl = config.base_url + "container_reproductive/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    reorder: {
        url: baseUrl + "reorder",
        type: "post",
    },
    listByPhenologyId: {
        url: baseUrl + "listByPhenologyId",
        type: "get",
    },
    copyToPhonology: {
        url: baseUrl + "copyToPhonology",
        type: "get",
    }
} 
